var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useLucidSdk } from '#context';
import { useUserWorkspaces } from '#query-hooks';
import { LucidDevToolsKeyFactory } from './LucidDevToolsKeyFactory';
const LOGGED_IN_FILESPACES_REFETCH_INTERVAL = 300; // milliseconds
export const useLoggedInFilespaces = () => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { lucidSdk } = useLucidSdk();
    const { query: { data: workspaces = [] }, } = useUserWorkspaces();
    const loggedInWorkspaces = useMemo(() => workspaces
        .map((workspace) => lucidSdk.workspaceClient(workspace.id))
        .filter(
    // eslint-disable-next-line @typescript-eslint/no-misused-promises -- pre-existing async predicate (dev-tools only); behaviour unchanged by the lint migration
    async (workspaceClient) => (await workspaceClient.getLoginStatus()).isLoggedIn), [lucidSdk, workspaces]);
    const queryKey = LucidDevToolsKeyFactory.loggedInFilespaces();
    const query = useQuery({
        queryKey,
        refetchInterval: LOGGED_IN_FILESPACES_REFETCH_INTERVAL,
        enabled: loggedInWorkspaces.length > 0,
        queryFn: async () => {
            const loggedInFilespaces = loggedInWorkspaces.flatMap((workspace) => workspace.listLoggedInFilespaces());
            const lastQueryResult = queryClient.getQueryData(queryKey) ?? [];
            const newQueryResult = lastQueryResult.filter((filespace) => loggedInFilespaces.some((loggedInFilespace) => loggedInFilespace.getFilespaceId() ===
                filespace.data.id));
            if (newQueryResult.length === loggedInFilespaces.length) {
                return newQueryResult;
            }
            const newlyLoggedInFilespaces = loggedInFilespaces.filter((loggedInFilespace) => !newQueryResult.some((filespace) => filespace.data.id ===
                loggedInFilespace.getFilespaceId()));
            const filespacesData = new Map((await Promise.all(newlyLoggedInFilespaces.map((filespace) => lucidSdk
                .workspaceClient(filespace.getWorkspaceId())
                .getFilespace(filespace.getFilespaceId())))).map((filespaceData) => [filespaceData.id, filespaceData]));
            return [
                ...newQueryResult,
                ...newlyLoggedInFilespaces.map((filespace) => ({
                    client: filespace,
                    data: filespacesData.get(filespace.getFilespaceId()),
                })),
            ];
        },
    });
    return { query };
};
_react_refresh_temp_1(useLoggedInFilespaces, "AtlzWkD6+NaHBc3fkaWBSkNnOKE=", false, () => [useQueryClient, useLucidSdk, useUserWorkspaces, useQuery]);
